import { CookieConsent } from '@/components/popups/CookieConsent'
import { CourseLandingDark } from '@/components/variants/pages/course-dark'
import { CourseLandingLight } from '@/components/variants/pages/course-light'
import { useEffect } from 'react'
import { useSplitTest } from '@/hooks/SplitTest'
import { emitter } from '@/utils/emitter'

const CourseLanding = () => {
  const isSecondVariant = useSplitTest('secondVariant')

  useEffect(() => {
    if (isSecondVariant) {
      emitter.emit('variant-change', true)
    }
  }, [isSecondVariant])

  if (isSecondVariant) {
    return <CourseLandingDark></CourseLandingDark>
  } else {
    return <CourseLandingLight></CourseLandingLight>
  }
}

// @ts-ignore
CourseLanding.getLayout = function getLayout(page) {
  return (
    <>
      {page}
      <CookieConsent/>
    </>
  )
}

export default CourseLanding
